// src/components/intake/IntakeStepper.jsx
//
// The mock-up's step row: numbered circles joined by lines, done steps ticked
// in purple, the current one in gold. On a phone only the current step keeps
// its label, as the mock-up does.

import React from 'react';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { SP, FONT } from './intakeSx';

export default function IntakeStepper({ steps, active }) {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', pt: '22px', pb: '6px' }}
      aria-label={`Step ${active + 1} of ${steps.length}: ${steps[active]}`}
      role="group"
      data-testid="intake-stepper"
    >
      {steps.map((label, i) => {
        const done = i < active;
        const current = i === active;
        return (
          <React.Fragment key={label}>
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: '9px', flexShrink: 0 }}
              aria-current={current ? 'step' : undefined}
            >
              <Box
                sx={{
                  width: 26,
                  height: 26,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: FONT.mono,
                  fontSize: 12,
                  fontWeight: 600,
                  border: `1.5px solid ${done ? SP.purple : current ? SP.gold : SP.lineSoft}`,
                  bgcolor: done ? SP.purple : current ? SP.gold : SP.white,
                  color: done ? SP.white : current ? SP.purpleDeep : SP.gray,
                }}
              >
                {done ? <CheckIcon sx={{ fontSize: 15 }} /> : i + 1}
              </Box>
              <Box
                component="span"
                sx={{
                  fontFamily: FONT.mono,
                  fontSize: 11,
                  letterSpacing: '.03em',
                  color: current ? SP.black : SP.gray,
                  fontWeight: current ? 600 : 400,
                  display: { xs: current ? 'inline' : 'none', sm: 'inline' },
                }}
              >
                {label}
              </Box>
            </Box>
            {i < steps.length - 1 && (
              <Box
                aria-hidden="true"
                sx={{ flex: 1, minWidth: 12, height: '1.5px', mx: '10px', bgcolor: done ? SP.purpleSoft : SP.lineSoft }}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
}
